<template>
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.365 10.6749L22.0575 7.29491L19.7475 4.61991C19.3575 4.16991 18.795 3.90991 18.1975 3.90991C17.705 3.90991 17.23 4.08741 16.86 4.40991L4.57001 15.0624C3.72751 15.7924 3.62 17.0399 4.3275 17.9024L17.1125 33.5274L10.985 15.8249C10.2625 13.7374 11.31 11.4749 13.3675 10.6749H13.365Z"
            fill="#EF2059"
        />
        <path
            d="M32.6449 11.25L31.4149 8.05249C31.1124 7.26749 30.3449 6.73999 29.5049 6.73999C29.2524 6.73999 29.0024 6.78749 28.7649 6.87999L14.1049 12.58C13.0749 12.98 12.5524 14.1125 12.9124 15.155L18.4049 31.02V15.3375C18.4049 13.0825 20.2399 11.2475 22.4949 11.2475H32.6424L32.6449 11.25Z"
            fill="#EF2059"
        />
        <path
            d="M30.7925 21.1523C29.195 21.1523 27.9075 22.3023 27.9075 24.1223V26.2248C27.9075 27.9898 28.9725 29.1398 30.7925 29.1398C32.445 29.1398 33.735 27.8798 33.735 26.1698V24.1523C33.735 22.3873 32.39 21.1548 30.7925 21.1548V21.1523Z"
            fill="#EF2059"
        />
        <path
            d="M38.8601 13.2949H22.4976C21.3701 13.2949 20.4526 14.2124 20.4526 15.3399V38.8624C20.4526 39.9899 21.3701 40.9074 22.4976 40.9074H38.8601C39.9876 40.9074 40.9051 39.9899 40.9051 38.8624V15.3399C40.9051 14.2124 39.9876 13.2949 38.8601 13.2949ZM37.0951 26.6449C37.0951 30.0924 34.3776 32.2499 31.7151 32.2499C30.2576 32.2499 28.7176 31.8299 28.0176 31.0999H27.9051V36.8449H24.5426V18.2124H27.9051V19.3324H28.0176C28.6901 18.5474 30.1751 18.0149 31.7151 18.0149C34.5176 18.0149 37.0951 20.3974 37.0951 23.7024V26.6449Z"
            fill="#EF2059"
        />
    </svg>
</template>
